import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostAttachEVerifyDocumentToWorkerRequest } from "./postAttachEVerifyDocumentToWorkerSchema";

export const postAttachEVerifyDocumentToWorker = (axios: IAxiosInstance) => {
  return async (data: TPostAttachEVerifyDocumentToWorkerRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<boolean>>(
      "/api/postAttachEVerifyDocumentToWorker",
      { ...data }
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
